import { useDispatch, useSelector } from "react-redux";
import { MDBBtn, MDBBtnGroup, MDBCol } from "mdbreact";
import { SetActiveTab } from "../../../../services/redux/slices/diagnostics/clinic/dailyCollections";

const CollectionsTabs = () => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector(({ dailyCollections }) => dailyCollections);

  return (
    <MDBCol md="12" className="mb-4">
      <MDBBtnGroup>
        <MDBBtn
          color={activeTab === "list" ? "primary" : "mdb-color"}
          onClick={() => dispatch(SetActiveTab("list"))}
        >
          List
        </MDBBtn>
        <MDBBtn
          color={activeTab === "analytics" ? "primary" : "mdb-color"}
          onClick={() => dispatch(SetActiveTab("analytics"))}
        >
          Analytical Reports
        </MDBBtn>
      </MDBBtnGroup>
    </MDBCol>
  );
};

export default CollectionsTabs;
